export default {
  models: {
    name: {
      acs_server: {
        one: 'Servidor ACS',
        other: 'Servidores ACS',
        gender: 'male'
      },
      access_server: {
        one: 'Access Server',
        other: 'Access Servers',
        interface: {
          one: 'Interfaz',
          other: 'Interfaces'
        },
        access_profile: {
          one: 'Dominio',
          other: 'Dominios'
        },
        pool: {
          one: 'Pool',
          other: 'Pools'
        },
        network_ip_service: {
          one: 'Servicio de Red IP',
          other: 'Servicios de Red IP'
        }
      },
      address: {
        one: 'Dirección IP',
        other: 'Direcciones IP'
      },
      agent: {
        one: 'Box',
        other: 'Box'
      },
      alert: {
        one: 'Alerta',
        other: 'Alertas'
      },
      audit: {
        one: 'Auditoría',
        other: 'Auditorías'
      },
      automigrator: {
        one: 'Automigrador',
        other: 'Automigradores'
      },
      bmu_interfaces: {
        one: 'Interfaz BMU',
        other: 'Interfaces BMU'
      },
      bmus: {
        one: 'BMU',
        other: 'BMUs',
        interface: {
          one: 'Interfaz',
          other: 'Interfaces'
        }
      },
      changelog: {
        one: 'Changelog',
        other: 'Changelogs'
      },
      client: {
        one: 'Cliente',
        other: 'Clientes'
      },
      cloud_license: {
        acs: {
          one: 'Suscripción ACS',
          other: 'Suscripciones ACS '
        },
        hola_suite: {
          one: 'Suscripción Hola Suite',
          other: 'Suscripciones Hola Suite'
        },
        one: 'Suscripción Cloud',
        other: 'Suscripciones Cloud'
      },
      cluster: {
        one: 'Cluster',
        other: 'Clusters',
        service: {
          one: 'Servicio',
          other: 'Servicios',
          container: {
            one: 'Container',
            other: 'Containers'
          }
        },
        node: {
          one: 'Nodo',
          other: 'Nodos'
        },
        logs: {
          one: 'Log',
          other: 'Logs'
        },
        network: {
          one: 'Red',
          other: 'Redes'
        },
        volume: {
          one: 'Volumen',
          other: 'Volúmenes'
        },
        secret: {
          one: 'Secreto',
          other: 'Secretos'
        }
      },
      conciliation: {
        one: 'Conciliación',
        other: 'Conciliaciones',
        gender: 'male'
      },
      contract: {
        one: 'Contrato',
        other: 'Contratos',
        gender: 'male'
      },
      coverage: {
        one: 'Cobertura',
        other: 'Coberturas'
      },
      dashboard: {
        one: 'Panel de Control',
        other: 'Paneles de Control'
      },
      dhcp_server: {
        one: 'Servidor DHCP',
        other: 'Servidores DHCP'
      },
      document: {
        block: {
          one: 'Bloque',
          other: 'Bloques'
        },
        template: {
          one: 'Plantilla',
          other: 'Plantillas'
        },
        template_management: {
          one: 'Gestión de plantilla',
          other: 'Gestión de plantillas'
        }
      },
      employee: {
        one: 'Empleado',
        other: 'Empleados'
      },
      export: {
        one: 'Exportación',
        other: 'Exportaciones'
      },
      fiber_configuration: {
        one: 'Configuración de Fibra Óptica',
        other: 'Configuraciones de Fibra Óptica'
      },
      gps_point: {
        one: 'Punto GPS',
        other: 'Puntos GPS'
      },
      helpdesk: {
        issue: {
          one: 'Ticket',
          other: 'Tickets'
        },
        issue_category: {
          one: 'Categoría',
          other: 'Categorías'
        },
        issue_comment: {
          one: 'Comentario',
          other: 'Comentarios'
        }
      },
      hola_notification: {
        one: 'Notificación',
        other: 'Notificaciones'
      },
      installation_order: {
        one: 'Orden de instalación',
        other: 'Órdenes de instalación'
      },
      installation_order_configuration: {
        one: 'Configuración de las órdenes de instalación',
        other: 'Configuraciones de las órdenes de instalación'
      },
      inventory: {
        article: {
          one: 'Artículo',
          other: 'Artículos'
        },
        dealer: {
          one: 'Distribuidor',
          other: 'Distribuidores'
        },
        movement: {
          one: 'Movimiento',
          other: 'Movimientos'
        },
        stock: {
          one: 'Stock',
          other: 'Stocks'
        },
        subscription: {
          one: 'Suscripción',
          other: 'Suscripción'
        },
        warehouse: {
          one: 'Almacén',
          other: 'Almacenes'
        }
      },
      invoices: {
        one: 'Factura',
        other: 'Facturas'
      },
      invoicing: {
        abstract_invoice: {
          one: 'Factura / Nota de Crédito',
          other: 'Notas de Crédito'
        },
        cash_audit: {
          one: 'Arqueo de caja',
          other: 'Arqueos de caja'
        },
        cash_audit_transaction: {
          one: 'Arqueo de caja',
          other: 'Arqueos de caja'
        },
        categories: {
          one: 'Categoría',
          other: 'Categorías'
        },
        clients_payment_gateway: {
          one: 'Pasarela de pago',
          other: 'Pasarelas de pago'
        },
        contract_discount: {
          one: 'Descuento',
          other: 'Descuentos'
        },
        credit_note: {
          one: 'Nota de crédito',
          other: 'Notas de crédito'
        },
        credit_note_pool_number: {
          one: 'Numeración Notas de Crédito',
          other: 'Numeración Notas de Crédito'
        },
        current_account: {
          one: 'Cuenta corriente',
          other: 'Cuentas corrientes'
        },
        discount: {
          one: 'Descuento',
          other: 'Descuentos'
        },
        einvoice: {
          one: 'Factura electrónica',
          other: 'Facturas electrónicas'
        },
        invoice: {
          one: 'Factura',
          other: 'Facturas'
        },
        invoice_item: {
          one: 'Item',
          other: 'Items'
        },
        invoice_item_kind: {
          one: 'Item',
          other: 'Items'
        },
        invoice_pool_number: {
          one: 'Numeración autorizada DIAN',
          other: 'Numeración autorizada DIAN'
        },
        invoices_payment_gateway: {
          one: 'Cupón de pago',
          other: 'Cupones de pago'
        },
        invoicing_firm: {
          one: 'Razón Social',
          other: 'Razones Sociales'
        },
        invoicing_configuration: {
          one: 'Configuración',
          other: 'Configuraciones'
        },
        payment: {
          one: 'Pago',
          other: 'Pagos'
        },
        payment_gateway: {
          one: 'Pasarela de pagos',
          other: 'Pasarelas de pago',

          vippo: {
            transaction_report: {
              one: 'Reporte de Transacción',
              other: 'Reportes de transacción'
            }
          }
        },
        payment_gateway_transaction: {
          one: 'Transacción en pasarela',
          other: 'Transacciones en pasarela'
        },
        payment_promise: {
          one: 'Promesa de pago',
          other: 'Promesas de pago'
        },
        payment_receipt: {
          one: 'Comprobante de Pago',
          other: 'Comprobantes de Pago'
        },
        payment_transaction: {
          one: 'Transacción de Pago',
          other: 'Transacciones de Pago'
        },
        pool_number: {
          one: 'Numeración',
          other: 'Numeración'
        },
        profile: {
          one: 'Perfil',
          other: 'Perfiles'
        },
        recurring_item: {
          one: 'Item Recurrente',
          other: 'Items Recurrentes'
        },
        tax: {
          one: 'Impuesto',
          other: 'Impuestos'
        },
        transaction: {
          one: 'Transacción de cuenta corriente',
          other: 'Transacciones de cuenta corriente'
        },
        transaction_kind: {
          one: 'Forma de pago',
          other: 'Formas de pago' // INVOICING
        }
      },
      invoicing_firm: {
        one: 'Razón Social',
        other: 'Razones Sociales'
      },
      invoicing_payment: {
        one: 'Pago',
        other: 'Pagos'
      },
      isp: {
        one: 'Isp',
        other: 'Isps'
      },
      map: {
        one: 'Map',
        other: 'Maps'
      },
      mikrotik: {
        one: 'Mikrotik',
        other: 'Mikrotiks',
        interface: {
          one: 'Interfaz',
          other: 'Interfaces'
        }
      },
      nap: {
        one: 'NAP',
        other: 'NAPs',
        gender: 'female'
      },
      nap_port: {
        one: 'Puerto NAP',
        other: 'Puertos NAP',
        gender: 'male'
      },
      nas: { one: 'NAS', other: 'NAS' },
      neighborhood: {
        one: 'Barrio',
        other: 'Barrios'
      },
      olt_server_interfaces: {
        one: 'Red',
        other: 'Redes'
      },
      new: {
        one: 'Novedad',
        other: 'Novedades'
      },
      node: {
        one: 'Nodo',
        other: 'Nodos'
      },
      notification_mail: {
        one: 'Notificación de correo',
        other: 'Notificaciones de correo'
      },
      notification_mobile: {
        one: 'Notificación Móvil',
        other: 'Notificaciones Moviles'
      },
      notification_sms: {
        one: 'Notificación SMS',
        other: 'Notificaciones SMS'
      },
      notification_web: {
        one: 'Notificación Web',
        other: 'Notificaciones Web'
      },
      notifications: {
        one: 'Notificación',
        other: 'Notificaciones'
      },
      mikrotik_interfaces: {
        one: 'Interfaz Mikrotik',
        other: 'Interfaces Mikrotik'
      },
      olt: {
        one: 'OLT',
        other: 'OLTs',
        gender: 'female',
        gpon_port: {
          one: 'Puerto GPON',
          other: 'Puertos GPON'
        },
        pon_interfaces: {
          one: 'Puerto PON',
          other: 'Puertos PON'
        },
        uplink_interfaces: {
          one: 'Interfaz Uplink',
          other: 'Interfaces Uplink'
        }
      },
      ont: {
        one: 'ONU',
        other: 'ONUs'
      },
      onu: {
        one: 'ONU',
        other: 'ONUs'
      },
      orders: {
        feedback: {
          one: 'Feedback',
          other: 'Feedbacks'
        },
        feedback_kind: {
          one: 'Tipo de Feedback',
          other: 'Tipos de Feedback'
        },
        order: {
          one: 'Orden',
          other: 'Órdenes'
        },
        order_configuration: {
          one: 'Configuración de Órdenes',
          other: 'Configuraciones de Órdenes'
        },
        parameter: {
          one: 'Parámetro',
          other: 'Parámetros'
        }
      },
      payment_promise: {
        one: 'Promesa de pago',
        other: 'Promesas de pago'
      },
      payment_receipt: {
        one: 'Comprobante de Pago',
        other: 'Comprobantes de Pago'
      },
      plan: {
        one: 'Plan',
        other: 'Planes'
      },
      portal_configuration: {
        one: 'Configuración de Portal',
        other: 'Configuraciones de Portal'
      },
      ppp_profile: {
        one: 'Perfil PPP',
        other: 'Perfiles PPP'
      },
      preselection: {
        other: 'Pre Selección'
      },
      provider: {
        one: 'Proveedor',
        other: 'Proveedores'
      },
      push_notification: {
        one: 'Notificaciones de Dispositivo',
        other: 'Notificaciones de Dispositivos'
      },
      record: {
        one: 'Registro',
        other: 'Registros'
      },
      referral: {
        credited_payment: {
          one: 'pago acreditado',
          other: 'pagos acreditados'
        },
        payment: {
          one: 'Pago',
          other: 'Pagos'
        },
        transaction: {
          one: 'Transacción',
          other: 'Transacciones'
        }
      },
      sale_desk: {
        lead: {
          gender: 'male',
          one: 'Lead',
          other: 'Leads'
        },
        prospect: {
          gender: 'male',
          one: 'Prospecto',
          other: 'Prospectos'
        },
        source: {
          gender: 'male',
          one: 'Origen',
          other: 'Origenes'
        },
        tags: {
          gender: 'male',
          one: 'Etiqueta',
          other: 'Etiquetas'
        },
        ticket: {
          gender: 'male',
          one: 'Ticket',
          other: 'Tickets'
        },
        contact: {
          gender: 'male',
          one: 'Contacto',
          other: 'Contactos'
        }
      },
      seal: {
        one: 'Precinto',
        other: 'Precintos',
        gender: 'male'
      },
      sent_sms: {
        one: 'SMS Enviado',
        other: 'SMS Enviados'
      },
      server_configuration: {
        one: 'Servidor',
        other: 'Servidores'
      },
      smtp_configuration: {
        one: 'Configuración de SMTP',
        other: 'Configuraciones de SMTP'
      },
      template: {
        one: 'Plantilla',
        other: 'Plantillas'
      },
      template_hola: {
        one: 'Plantilla de Hola',
        other: 'Plantillas de Hola'
      },
      transaction: {
        one: 'Transacción',
        other: 'Transacciones'
      },
      tv_service: {
        one: 'Servicio de TV',
        other: 'Servicios de TV',

        directv_go: {
          subscription: {
            one: 'Suscripción',
            other: 'Suscripción'
          },
          pack: {
            one: 'Paquete',
            other: 'Paquetes'
          }
        }
      },
      wholesale_pack: {
        one: 'WholesalePack',
        other: 'WholesalePacks'
      },
      wholesale_pack_agreement: {
        one: 'Acuerdo mayorista',
        other: 'Acuerdos mayoristas'
      },
      zone: {
        one: 'Zona',
        other: 'Zonas'
      }
    }
  }
};
